import { render, staticRenderFns } from "./user-column.vue?vue&type=template&id=bab60e26&scoped=true"
import script from "./user-column.vue?vue&type=script&lang=js"
export * from "./user-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab60e26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab60e26')) {
      api.createRecord('bab60e26', component.options)
    } else {
      api.reload('bab60e26', component.options)
    }
    module.hot.accept("./user-column.vue?vue&type=template&id=bab60e26&scoped=true", function () {
      api.rerender('bab60e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-quarantine/columns/user-column.vue"
export default component.exports